import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from '@chakra-ui/core';
import { I9KeysAndUrl } from './keys/I9KeysAndUrl';
import { useStoreState } from '../../../models/hooks';
import { I9Turtorial } from './turtorial/I9Turtorial';

export const I9IntegrationView = (): JSX.Element => {
  const { user } = useStoreState((s) => s.app);
  const { t } = useTranslation('i9Verification');

  return (
    <React.Fragment>
      <Box data-testid="I9IntegrationView">
        <Tabs colorScheme="blue">
          <TabList borderWidth={0} px={2} mb={6} borderRadius={5} backgroundColor="white">
            <Tab
              py={3}
              fontSize="sm"
              _selected={{ fontWeight: '700', borderColor: 'blue.default', color: 'blue.default' }}
              _focus={{ boxShadow: 'none' }}
            >
              {t('keysUrlLabel')}
            </Tab>
            <Tab
              py={3}
              fontSize="sm"
              _selected={{ fontWeight: '700', borderColor: 'blue.default', color: 'blue.default' }}
              _focus={{ boxShadow: 'none' }}
            >
              {t('i9SetupLabel')}
            </Tab>
          </TabList>
          <TabPanels backgroundColor="white" borderRadius={5}>
            <TabPanel p={0}>
              <I9KeysAndUrl accountId={user?.account} />
            </TabPanel>
            <TabPanel p={0}>
              <I9Turtorial />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </React.Fragment>
  );
};
